import React, { Component } from 'react'
import Table from "../../../components/UI/Table/Table";
// import './Table.css';
import { DEFAULT_PAGE_SIZE } from './constants';
import { Button } from 'reactstrap';
import moment from 'moment';
import '../style.scss';

let that;

const BULK_CASE_TABLE_COLUMN = [
    {
        Header: "Created At",
        id: "createdAt",
        accessor: d => <div>{moment(d.createdAt).format('DD-MM-YYYY')}</div>
    },
    {
        Header: "Created By",
        id: "createdBy",
        // maxWidth: 100,
        accessor: p => <div>{p.createdBy}</div>,

    },
    {
        Header: 'Request Record',
        id: 'action',
        accessor: p => <Button color='primary' onClick={() => that.handleOrignalFileDownload(p)}><i className="fa fa-download"></i></Button>
    }
];

class TableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            recordsAndNoOfPages: this.props.listAndNoOfPages,
            sorted: {
                id: "createdAt",
                desc: true
            },
            pageSize: DEFAULT_PAGE_SIZE,
            currentPageIndex: 0
        };
        that = this
    }

   
    componentDidUpdate(prevProps) {
        if (this.props.listAndNoOfPages !== prevProps.listAndNoOfPages) {
            this.setState({
                recordsAndNoOfPages: this.props.listAndNoOfPages
            } );
        }
    }
    
    handleOrignalFileDownload = (data) => {
        this.props.downloadOrignal(data);
    }


    render() {
        return (
            <Table
                data={(this.state.recordsAndNoOfPages.recordList) ? this.state.recordsAndNoOfPages.recordList : []}
                columns={BULK_CASE_TABLE_COLUMN}
                defaultSorted={[
                    {
                        id: "createdAt",
                        desc: true
                    }
                ]}
                className=""
                noDataText="No Records found"
                multiSort={false}
                pages={this.state.recordsAndNoOfPages.numberOfPages}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual  // this would indicate that server side pagination has been enabled 
                loading={this.props.loading}
                onPageChange={(pageIndex) => { // Called when the page index is changed by the user
                    this.setState({
                        currentPageIndex: pageIndex
                    });
                    this.props.onFetchPage({caseType: this.props.caseType, pageNumber: pageIndex, pageSize: this.state.pageSize, sortField: this.state.sorted.id, sortDirection: (this.state.sorted.desc) ? 'desc' : 'asc' });
                }}
                onSortedChange={(newSorted, column, shiftKey) => { // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
                    this.setState({
                        sorted: newSorted[0]
                    });
                    this.props.onFetchPage({caseType: this.props.caseType, pageNumber: 0, pageSize: this.state.pageSize, sortField: newSorted[0].id, sortDirection: (newSorted[0].desc) ? 'desc' : 'asc' });
                }}
                onPageSizeChange={(pageSize, pageIndex) => {
                    this.setState({
                        pageSize: pageSize
                    })
                    this.props.onFetchPage({caseType: this.props.caseType, pageNumber: 0, pageSize: pageSize, sortField: this.state.sorted.id, sortDirection: (this.state.sorted.desc) ? 'desc' : 'asc' });
                }}
            />
        )
    }
}

export default TableView
